import React, { useContext, useEffect, useState } from "react";
import MDModal from "components/MDModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { ModalContext } from "context/ModalContext";
import { LoginFormContext } from "context/LoginFormContext";
import { eventList } from "Apis/event";
import { getEventById } from "Apis/event";
import { deleteEventById } from "Apis/event";
import { allAdminListApi } from "Apis/admin";
import { MODULES } from "helpers/constant";
import moment from "moment";
import EventForm from "./Form";
import { EventContext } from "context/EventContext";
import UpdateStatus from "components/MDUpdateStatus";
import event from "../../../assets/images/placeholder.jpg";
import MDActionButton from "components/MDActionButton";
import colors from "assets/theme/base/colors";
import Imagepreview from "components/MDImagePreview";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import { Box } from "@mui/material";

const Event = () => {
  const { showMessageNotification, setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const {
    setNotification,
    modules,
    getModuleAccess,
    access,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
  } = useContext(LoginFormContext);
  const { setEditData } = useContext(EventContext);
  const [eventData, setEventData] = useState([]);
  const [adminList, setAdminList] = useState([]);
  const { imageBorder } = colors;
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });

  const handleEditDelete = async (row, type) => {
    if (type === "Edit") {
      let response = await getEventById(row.id);
      if (response?.status === 200) {
        setFilterLoader(false);
        setEditData(response?.data?.data);
        setOpen(true);
        setFormIsEdit(true);
      }
    }

    if (type === "Delete") {
      showMessageNotification({
        title: "Are you sure?",
        text: "You want to delete this event!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result?.isConfirmed) {
          let deleteResponse = await deleteEventById(row.id);
          if (deleteResponse?.status === 200) {
            setFilterLoader(false);
            setOpen(false);
            eventData?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
            getEventList();
            setNotification({
              color: "success",
              icon: "check",
              title: "Success",
              content: deleteResponse?.data?.message,
              open: true,
            });
          } else {
            setNotification({
              color: "error",
              icon: "check",
              title: "error",
              content: deleteResponse?.data?.message,
              open: true,
            });
          }
        }
      });
    }
  };

  const getAdminApi = async (id) => {
    let response = await allAdminListApi(id);
    if (response?.status === 200) {
      setAdminList(
        response.data.data.map((item) => ({
          id: parseInt(item?.id),
          label: item?.first_name + " " + item?.last_name,
        }))
      );
    }
  };

  const [filterVal, setFilterVal] = useState({
    added_by: "",
    title: "",
    location: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      added_by: filterVal.added_by,
      title: filterVal.title,
      location: filterVal.location,
      start_date: filterVal?.start_date
        ? moment(filterVal?.start_date?.$d).format("YYYY-MM-DD")
        : "",
      end_date: filterVal?.end_date ? moment(filterVal?.end_date?.$d).format("YYYY-MM-DD") : "",
      is_active: filterVal?.is_active?.value,
      start_time: filterVal?.start_time || "",
      end_time: filterVal?.end_time || "",
    },
  };

  const getEventList = async (data) => {
    let response = await eventList(Obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setEventData(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.EVENT);
  }, [modules]);

  useEffect(() => {
    getEventList();
  }, [filterVal, defaultFilter]);

  useEffect(() => {
    getAdminApi();
  }, []);

  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  let data = {
    isFilter: true,
    columns: [
      {
        Header: "Title",
        accessor: "title",
        minWidth: "85px",
        sort: true,
        filterLabel: "Title",
        filterAccessor: "title",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value, row }) => {
          const imageUrl = row?.original?.event_images[0]?.image;

          const [imgError, setImgError] = React.useState(false);

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {imageUrl && !imgError ? (
                <img
                  src={imageUrl}
                  alt="image"
                  onError={() => setImgError(true)}
                  onClick={() => handleImageClick(imageUrl)}
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                    objectFit: "cover",
                    border: `1px solid ${imageBorder.borderColor}`,
                    cursor: "pointer",
                  }}
                />
              ) : (
                <img
                  src={event}
                  alt="image"
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                    objectFit: "fill",
                    border: `1px solid ${imageBorder.borderColor}`,
                  }}
                />
              )}
              <DefaultCell value={value || "-"} />
            </div>
          );
        },
      },
      {
        Header: "Start Date & Time",
        accessor: "start_date",
        minWidth: "150px",
        sort: true,
        Cell: ({ value, row }) => {
          const startDate = value;
          const startTime = row?.original?.start_time;

          if (!startDate) return <DefaultCell value="-" />;

          const dateTimeString = startTime
            ? `${startDate} ${moment(startTime, "HH:mm:ss").format("hh:mm A")}`
            : startDate;

          return <DefaultCell value={dateTimeString} />;
        },
      },
      {
        Header: "End Date & Time",
        accessor: "end_date",
        minWidth: "150px",
        sort: true,
        Cell: ({ value, row }) => {
          const endDate = value;
          const endTime = row?.original?.end_time;

          if (!endDate) return <DefaultCell value="-" />;

          const dateTimeString = endTime
            ? `${endDate} ${moment(endTime, "HH:mm:ss").format("hh:mm A")}`
            : endDate;

          return <DefaultCell value={dateTimeString} />;
        },
      },
      {
        Header: "Added By",
        accessor: "added_by",
        minWidth: "85px",
        filterLabel: "Added By",
        filterAccessor: "added_by",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => {
          const admin = adminList.find((item) => item.id === value);
          return <DefaultCell value={admin ? admin.label : "-"} />;
        },
      },
      {
        Header: "Total Bookings",
        minWidth: "85px",
        Cell: ({ value, row }) => {
          const {
            total_bookings,
            total_members_bookings,
            total_member_guests_bookings,
            total_guest_bookings,
          } = row?.original?.bookings_details || {};

          return total_bookings > 0 ? (
            <Box sx={{ textAlign: "left", width: "220px", color: "#7b809a" }}>
              <div>Total Member Bookings: {total_members_bookings}</div>
              <div>Total Member Guest Booking: {total_member_guests_bookings}</div>
              <div>Total Guest Booking: {total_guest_bookings}</div>
              <div
                style={{
                  fontWeight: "bold",
                  marginTop: "4px",
                  borderTop: "1px solid #ddd",
                  paddingTop: "4px",
                }}
              >
                Total: {total_bookings}
              </div>
            </Box>
          ) : (
            <div>-</div>
          );
        },
      },
      {
        Header: "Total Attendances",
        minWidth: "120px",
        Cell: ({ value, row }) => {
          const { total_attendances } = row?.original?.attendances_details || {};

          return total_attendances > 0 ? (
            <Box sx={{ textAlign: "left", width: "150px", color: "#7b809a" }}>
              <div>{total_attendances}</div>
            </Box>
          ) : (
            <div>-</div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "is_active",
        minWidth: "115px",
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="events"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ value, row }) => (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {access?.write_access && (
              <MDActionButton type="edit" onClick={() => handleEditDelete(row?.original, "Edit")} />
            )}
            {access?.delete_access && (
              <MDActionButton
                type="delete"
                onClick={() => handleEditDelete(row?.original, "Delete")}
              />
            )}
          </MDBox>
        ),
      },
    ],
    rows: eventData,
  };

  return (
    !isLoading && (
      <DashboardLayout>
        <DashboardNavbar />
        <>
          <MDModal
            hasButton={access?.write_access ?? false}
            btnText="Add Event"
            modalHead={`${formIsEdit ? "Edit" : "Add"} Event`}
          >
            <EventForm getEventList={getEventList} />
          </MDModal>
          <DataTable
            table={data}
            isSorted={false}
            entriesPerPage={true}
            showTotalEntries={true}
            noEndBorder
            canFilter
            canSearch={true}
            rowCount={rowCount}
            getDataList={getEventList}
            tableTitle="Event List"
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
          />
          {selectedImage && (
            <Imagepreview
              open={isImageModalOpen}
              onClose={() => setIsImageModalOpen(false)}
              imageUrl={selectedImage}
            />
          )}
        </>
      </DashboardLayout>
    )
  );
};

Event.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
  getEventList: PropTypes.func,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default Event;
